import { useUrlSearchParams } from '@vueuse/core'
import { useRoutePath } from './useRoutePath'
import { useSingleton } from './useSingleton'

function createInstance() {
  const params = reactive(useUrlSearchParams())
  const reset = () => Object.assign(params, useUrlSearchParams())
  const { routePath } = useRoutePath()

  watch(routePath, () => {
    reset()
  })

  return params
}

export const useSearchParams = useSingleton(createInstance)
